<script setup lang="ts">
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { ref } from 'vue'
import Reinforce from './components/Reinforce.vue'
import RiseStar from './components/RiseStar.vue'
import Inherit from './components/Inherit.vue'
import Recast from './components/Recast.vue'

const curTab = ref('reinforce')
</script>

<template>
  <div class="smithy-page page">
    <h2>铁匠铺</h2>

    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="强化" name="reinforce" class="pane" lazy>
        <Reinforce class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="继承" name="inherit" class="pane" lazy>
        <Inherit class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="升星" name="riseStar" class="pane" lazy>
        <RiseStar class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="重铸" name="recast" class="pane" lazy>
        <Recast class="pane-item" />
      </el-tab-pane>
    </el-tabs>
    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.smithy-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
